module.exports = __webpack_public_path__ + "img/l2.69f8f42b.png";